export default [
    {
        path: "/acciones-movimientos/ascenso",
        name: "ascenso",
        component: () => import(/* webpackChunkName: "ascenso" */ "../index.vue"),
    },
    {
        path: "/acciones-movimientos/ascenso/requerimiento/:id",
        name: "solicitud-detalle",
        component: () => import(/* webpackChunkName: "solicitud-detalle" */ "../views/SolicitudPanelView.vue"),
    },
    {
        path: "/acciones-movimientos/ascenso/requerimiento-solicitud/:id?",
        name: "ascenso-crear",
        component: () => import(/* webpackChunkName: "ascenso-crear" */ "../Pages/EnviarRequerimientos.vue"),
    },
    {
        path: "/acciones-movimientos/ascenso/solicitud/:id?",
        name: "ascenso-solicitud",
        component: () =>
            import( /* webpackChunkName: "ascenso-solicitud" */ "@/views/acciones-movimientos/v2/ascenso/infoAscenso.vue" ),
    },
]